import {
  keyProtectAdditionalEquipmentVulcan,
  keyControlAdditionalEquipmentVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  protectIncludedPoeTurretCameraVulcan,
  smartCameraAdditionalEquipmentVulcan,
  smartCameraIncludedEquipmentCameraSelectionVulcan,
  smartCameraIncludedPoeTurretCameraVulcan,
  poeDomeCamera,
  easyThreeYearPoeDomeCamera,
  easyFiveYearPoeDomeCamera,
  poeBracketVulcan,
  powergDoorWindowSensorAuxVulcan,
  easyThreeYearPowergDoorWindowSensorAuxVulcan,
  easyFiveYearPowergDoorWindowSensorAuxVulcan,
  powergDoorWindowSensorVulcan,
  easyThreeYearPowergDoorWindowSensorVulcan,
  easyFiveYearPowergDoorWindowSensorVulcan
} from '../../../../utils/constant';

// Additional-equipment section key for each plan radio selection.
const additionalEquipmentKeyByRadio = {
  protect: keyProtectAdditionalEquipmentVulcan,
  control: keyControlAdditionalEquipmentVulcan,
  monitor: keyMonitorAdditionalEquipmentVulcan
};

// PowerG Door/Window Sensor: when an "Aux" variant is added, automatically
// add the matching "Contact" variant at $0. SWT for the Contact comes from
// Contentful and is consumed by calculateSWT in the installation-fee calc.
const powergSensorAuxToContactMap = {
  [powergDoorWindowSensorAuxVulcan]: {
    contactKey: powergDoorWindowSensorVulcan,
    priceField: 'oneTimePrice'
  },
  [easyThreeYearPowergDoorWindowSensorAuxVulcan]: {
    contactKey: easyThreeYearPowergDoorWindowSensorVulcan,
    priceField: 'threeYearEasyPayment'
  },
  [easyFiveYearPowergDoorWindowSensorAuxVulcan]: {
    contactKey: easyFiveYearPowergDoorWindowSensorVulcan,
    priceField: 'fiveYearEasyPayment'
  }
};

export const syncPowergContactFromAux = (fields, fieldName, value, radioSelection) => {
  const mapping = powergSensorAuxToContactMap[fieldName];
  if (!mapping) return;
  const sectionKey = additionalEquipmentKeyByRadio[radioSelection];
  if (!sectionKey) return;
  const section = fields[sectionKey];
  const contactField = section && section[mapping.contactKey];
  if (!contactField) return;

  const qty = parseInt(value, 10) || 0;
  contactField.value = qty;
  contactField.isVisible = qty > 0;
  // Force $0 price on the auto-added contact regardless of upstream values.
  contactField.oneTimePrice = 0;
  contactField.monthlyPayment = 0;
  contactField.threeYearEasyPayment = 0;
  contactField.fiveYearEasyPayment = 0;
  contactField[mapping.priceField] = 0;
};

// PoE Dome Camera: the single one-time PoE Bracket (poeBracketVulcan) is
// auto-managed to cover every PoE Dome Camera across all payment tiers. For
// the Protect and Smart Camera plans it also covers the plan's included PoE
// turret camera (neither plan has a separate included bracket anymore). Bracket
// pricing remains driven by Contentful. Only applies to Protect and Smart
// Camera plans.
const poeDomeCameraFields = [
  poeDomeCamera,
  easyThreeYearPoeDomeCamera,
  easyFiveYearPoeDomeCamera
];
const poeDomeBracketSectionKeyByRadio = {
  protect: keyProtectAdditionalEquipmentVulcan,
  smartCa: smartCameraAdditionalEquipmentVulcan
};
// Included PoE turret cameras that also feed the one-time bracket.
const bracketIncludedTurretByRadio = {
  protect: {
    sectionKey: keyProtectIncludedEquipmentCameraSelectionVulcan,
    field: protectIncludedPoeTurretCameraVulcan
  },
  smartCa: {
    sectionKey: smartCameraIncludedEquipmentCameraSelectionVulcan,
    field: smartCameraIncludedPoeTurretCameraVulcan
  }
};

export const syncPoeBracketFromDomeCamera = (fields, fieldName, value, radioSelection) => {
  const sectionKey = poeDomeBracketSectionKeyByRadio[radioSelection];
  if (!sectionKey) return;
  const section = fields[sectionKey];
  const bracketField = section && section[poeBracketVulcan];
  if (!bracketField) return;

  const domeTotal = poeDomeCameraFields.reduce(
    (acc, f) => acc + (parseInt((section[f] || {}).value, 10) || 0),
    0
  );

  const turretConfig = bracketIncludedTurretByRadio[radioSelection];
  let includedTurret = 0;
  if (turretConfig) {
    const includedSection = fields[turretConfig.sectionKey] || {};
    includedTurret = parseInt((includedSection[turretConfig.field] || {}).value, 10) || 0;
  }

  const total = domeTotal + includedTurret;
  bracketField.value = total;
  bracketField.isVisible = total > 0;
};
